import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';

import PaymentPage from "./Components/PaymentPage";
import { UserProvider } from './Components/UserContext';


const App: React.FC = () => {
    return (
        <UserProvider>
            <Router>
                <Routes>
                    <Route path="/pay/:paramProductID/:paramJWT/:paramCoupon?" element={<PaymentPage />} />
                    <Route path="/pay/:paramProductID" element={<PaymentPage />} />
                </Routes>
            </Router>
        </UserProvider>
    );
};

export default App;
